import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Datatable from '../../components/shared/datatable/Datatable';
import { useGetTrackedUsersDetailsQuery } from '../../app/userApi/userApi';
import { formatDateToMDY } from '../../helpers/Utils';
import Button from '../../components/shared/buttons/button';
import { AiOutlineEye } from 'react-icons/ai';

const TrackingUsers = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const { data: trackingUsers, isLoading, isFetching } = useGetTrackedUsersDetailsQuery({
    page,
    limit: 10,
    search,
    startDate,
    endDate,
  });

  const onPageChange = (newPage) => {
    setPage(newPage);
  };

  const handleSearch = (value) => {
    setSearch(value);
    setPage(1);
  };
const NA = "Not Available";

const valueOrNA = (value) =>
  value !== null && value !== undefined && value !== ""
    ? value
    : NA;
const columns = [

  {
    label: 'User IP',
    accessor: 'currentStep',
    cell: ({ row }) => <>{valueOrNA(row?.host_ip)}</>,
  },
  {
    label: 'Browser',
    accessor: 'currentStep',
    cell: ({ row }) => <>{valueOrNA(row?.host_browser)}</>,
  },
  {
    label: 'Device',
    accessor: 'host_device',
    cell: ({ row }) => <>{valueOrNA(row?.host_device)}</>,
  },
  {
    label: 'Country',
    accessor: 'host_country',
    cell: ({ row }) => <>{valueOrNA(row?.host_country)}</>,
  },
  {
    label: 'Address',
    accessor: 'address',
    cell: ({ row }) => <>{valueOrNA(row?.address)}</>,
  },
  {
    label: 'Postcode',
    accessor: 'post_code',
    cell: ({ row }) => <>{valueOrNA(row?.post_code)}</>,
  },
  {
    label: 'Visited At',
    accessor: 'createdAt',
    cell: ({ row }) =>
      row?.createdAt
        ? formatDateToMDY(row.createdAt)
        : "Not Available",
  },
  {
    label: 'View',
    accessor: 'action',
    cell: ({ row }) => (
      <Button
        icon={<AiOutlineEye size={20} />}
        className="borderedBtn"
        size="xs"
        label="View"
        onClick={() => navigate(`/user-tracking/details/${row?._id}`)}
      />
    ),
  },
];

  return (
    <div className="tracking-users-container">
      <div className="date-filter-row mb-3 d-flex gap-3 align-items-center">
        <div className="filter-group d-flex align-items-center gap-2">
          <label>From:</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => {
              setStartDate(e.target.value);
              if (endDate && e.target.value > endDate) {
                setEndDate(e.target.value);
              }
              setPage(1);
            }}
            className="form-control date-input-sm"
          />
        </div>
        <div className="filter-group d-flex align-items-center gap-2">
          <label>To:</label>
          <input
            type="date"
            value={endDate}
            min={startDate}
            onChange={(e) => {
              setEndDate(e.target.value);
              setPage(1);
            }}
            className="form-control date-input-sm"
          />
        </div>
      </div>
      <Datatable
        isLoading={isLoading || isFetching}
        tableData={trackingUsers?.data}
        columns={columns}
        page={page}
        onPageChange={onPageChange}
        showPegination={true}
        isFetching={isFetching}
        showFilter={true}
        onFilterSearch={handleSearch}
      />
    </div>
  );
};

export default TrackingUsers;
